export default "__VITE_ASSET__DckuehA8__"